import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useNotifications } from 'src/utils/hooks';

const SEND_MEMBERSHIP_EMAIL_MUTATION = gql`
  mutation SendMembershipEmail($addressId: String!, $clientId: String!) {
    sendMembershipEmail(params: { clientId: $clientId, addressId: $addressId }) {
      success
    }
  }
`;

export interface SendMembershipEmailInput {
  addressId: string;
  clientId: string;
}

interface SendMembershipEmailMutation {
  sendMembershipEmail: { success: boolean };
}
export const useMembershipEmail = (
  options?: MutationHookOptions<SendMembershipEmailMutation>,
) => {
  const { showSuccessAlert } = useNotifications();

  const [sendMembershipEmailMutation, { loading }] = useMutation<SendMembershipEmailMutation>(
    SEND_MEMBERSHIP_EMAIL_MUTATION,
    {
      ...options,
      onCompleted: () => {
        showSuccessAlert('Follow-up submitted');
      },
    },
  );

  const sendMembershipEmail = useCallback(
    async (input: SendMembershipEmailInput) => {
      if (!input.addressId || !input.clientId) return;

      const { data } = await sendMembershipEmailMutation({
        variables: {
          ...input,
        },
      });

      return data?.sendMembershipEmail?.success || false;
    },
    [sendMembershipEmailMutation],
  );

  return {
    sendMembershipEmail,
    loading,
  };
};
